import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'mj-autocomplete',
  template: `
    <mat-form-field class="autocomplete" [formGroup]="form">
      <input
        formControlName="autocomplete"
        [matAutocomplete]="autocomplete"
        [placeholder]="placeholder"
        matInput
        type="text"
        [required]="required"
      />
      <mat-autocomplete #autocomplete="matAutocomplete">
        <mat-option *ngFor="let item of items" [value]="item.text">
          {{ item.text }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  `,
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent implements OnInit, OnDestroy, OnChanges {
  @Input() placeholder: String;
  @Input() items: any[];
  @Input() selectedItem: any;
  @Input() required: boolean = false;
  @Output() onAutocomplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onInput: EventEmitter<any> = new EventEmitter<any>();
  form: any;
  autocompleteResults$: any;
  inputResults$: any;

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      autocomplete: '',
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedItem && this.selectedItem) {
      this.form.patchValue({
        autocomplete: this.selectedItem,
      });
    }
  }

  ngOnInit(): void {
    this.autocompleteResults$ = this.form
      .get('autocomplete')
      .valueChanges.pipe(
        debounceTime(400),
        distinctUntilChanged()
      )
      .subscribe(val => {
        this.onAutocomplete.emit(val);
      });
    this.inputResults$ = this.form
      .get('autocomplete')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe(val => {
        this.onInput.emit(val);
      });
  }

  ngOnDestroy() {
    if (this.autocompleteResults$) {
      this.autocompleteResults$.unsubscribe();
    }
    if (this.inputResults$) {
      this.inputResults$.unsubscribe();
    }
  }
}
